export enum PitchesRoutes {
  CreateOne = 'create-one',
  GetList = 'get-list',
  GetOne = 'get-one',
  GetReferenceList = 'get-reference-list',
  MarkAsDeleted = 'mark-as-deleted',
  Search = 'search',
  UpdateMany = 'update-many',
}
